"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* babel-plugin-inline-import './icon-arrow-left.svg' */
var left = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDE0Ij48cGF0aCBkPSJNLjAwOCA0Ljg5NWEuNzQzLjc0MyAwIDAxLjIzOC0uNTEyTDQuNjI0LjIzMUEuODIzLjgyMyAwIDAxNS4yIDBjLjQ0IDAgLjguMzQyLjguNzU5YS43NDIuNzQyIDAgMDEtLjI0NC41NDdMMS44ODIgNC45OGwzLjc5OSAzLjczYS43NDEuNzQxIDAgMDEuMjI0LjUzYzAgLjQxNi0uMzYxLjc2LS44Ljc2YS44MjMuODIzIDAgMDEtLjU3Ny0uMjMzbC00LjMtNC4yMjRhLjczOS43MzkgMCAwMS0uMjE5LS42NXoiIGZpbGw9IiM5NTlkYTciLz48L3N2Zz4=";
/* babel-plugin-inline-import './icon-arrow-right.svg' */
var right = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNiAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEuNDE0Ij48cGF0aCBkPSJNNS45OTIgNC44OTVhLjc0My43NDMgMCAwMC0uMjM4LS41MTJMMS4zNzYuMjMxQS44MjMuODIzIDAgMDAuOCAwYy0uNDQgMC0uOC4zNDItLjguNzU5IDAgLjIwNi4wODguNDAzLjI0NC41NDdMNC4xMTggNC45OC4zMiA4LjcxMWEuNzQxLjc0MSAwIDAwLS4yMjQuNTNjMCAuNDE2LjM2MS43Ni44Ljc2YS44MjMuODIzIDAgMDAuNTc3LS4yMzNsNC4zLTQuMjI0YS43MzkuNzM5IDAgMDAuMjE5LS42NXoiIGZpbGw9IiM5NTlkYTciLz48L3N2Zz4=";
var DataField = /*#__PURE__*/function (_PureComponent) {
  _inherits(DataField, _PureComponent);
  var _super = _createSuper(DataField);
  function DataField() {
    var _this;
    _classCallCheck(this, DataField);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      page: 0
    });
    _defineProperty(_assertThisInitialized(_this), "hasArrayChildren", function () {
      var _this$props = _this.props,
        pagination = _this$props.pagination,
        children = _this$props.children;
      return pagination && Array.isArray(children) && children.length > 1;
    });
    _defineProperty(_assertThisInitialized(_this), "sectionRef", /*#__PURE__*/_react.default.createRef());
    _defineProperty(_assertThisInitialized(_this), "handleSectionClick", function (event) {
      if (!_this.props.highlightContent) {
        return;
      }
      var selection = window.getSelection();
      var range = document.createRange();

      // If the target is the section itself, select all its content
      if (event.target === _this.sectionRef.current) {
        range.selectNodeContents(_this.sectionRef.current);
      } else {
        // If the target is a nested element, select its content
        range.selectNodeContents(event.target);
      }
      selection === null || selection === void 0 ? void 0 : selection.removeAllRanges();
      selection === null || selection === void 0 ? void 0 : selection.addRange(range);
    });
    _defineProperty(_assertThisInitialized(_this), "renderChildren", function () {
      var _this$props2 = _this.props,
        children = _this$props2.children,
        error = _this$props2.error;
      if (!children) return null;
      return /*#__PURE__*/_react.default.createElement("section", {
        ref: _this.sectionRef,
        onClick: _this.handleSectionClick,
        className: (0, _classnames.default)({
          'data-field_body': true,
          'error': error
        })
      }, _this.hasArrayChildren() ? children[_this.state.page] : children);
    });
    _defineProperty(_assertThisInitialized(_this), "prevPage", function () {
      var _this$props$onChangeP, _this$props3, _this$props$data;
      var page = _this.state.page;
      if (page === 0) return;
      _this.setState({
        page: page - 1
      });
      (_this$props$onChangeP = (_this$props3 = _this.props).onChangePage) === null || _this$props$onChangeP === void 0 ? void 0 : _this$props$onChangeP.call(_this$props3, (_this$props$data = _this.props.data) === null || _this$props$data === void 0 ? void 0 : _this$props$data[page - 1]);
    });
    _defineProperty(_assertThisInitialized(_this), "nextPage", function () {
      var _this$props$onChangeP2, _this$props4, _this$props$data2;
      var children = _this.props.children;
      var page = _this.state.page;
      if (children.length - 1 === page) return;
      _this.setState({
        page: page + 1
      });
      (_this$props$onChangeP2 = (_this$props4 = _this.props).onChangePage) === null || _this$props$onChangeP2 === void 0 ? void 0 : _this$props$onChangeP2.call(_this$props4, (_this$props$data2 = _this.props.data) === null || _this$props$data2 === void 0 ? void 0 : _this$props$data2[page + 1]);
    });
    _defineProperty(_assertThisInitialized(_this), "renderHeaderSelect", function () {
      var _this$props5 = _this.props,
        children = _this$props5.children,
        pagination = _this$props5.pagination;
      if (!Array.isArray(children) || !pagination || children.length <= 1) return null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "data-field_select"
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        elastic: true,
        onClick: _this.prevPage
      }, /*#__PURE__*/_react.default.createElement("img", {
        height: "10",
        src: left,
        alt: "l"
      })), /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        elastic: true,
        onClick: _this.nextPage
      }, /*#__PURE__*/_react.default.createElement("img", {
        height: "10",
        src: right,
        alt: "r"
      })));
    });
    _defineProperty(_assertThisInitialized(_this), "copyToClipboard", function (c) {});
    _defineProperty(_assertThisInitialized(_this), "getBasis", function () {
      if (!_this.props.basis) return {};
      return {
        flexBasis: _this.props.basis + '%'
      };
    });
    return _this;
  }
  _createClass(DataField, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$onChangeP3, _this$props6, _this$props$data3;
      (_this$props$onChangeP3 = (_this$props6 = this.props).onChangePage) === null || _this$props$onChangeP3 === void 0 ? void 0 : _this$props$onChangeP3.call(_this$props6, (_this$props$data3 = this.props.data) === null || _this$props$data3 === void 0 ? void 0 : _this$props$data3[0]);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        children = _this$props7.children,
        pagination = _this$props7.pagination,
        title = _this$props7.title,
        headerRight = _this$props7.headerRight,
        subtitle = _this$props7.subtitle;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: this.getBasis(),
        className: (0, _classnames.default)({
          'data-field': true,
          'grow': !!children
        })
      }, /*#__PURE__*/_react.default.createElement("header", {
        className: "data-field_header"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "data-field_headerLeft"
      }, title && /*#__PURE__*/_react.default.createElement("span", {
        className: "data-field_title"
      }, title), subtitle && /*#__PURE__*/_react.default.createElement("span", {
        className: "data-field_subtitle"
      }, subtitle), this.hasArrayChildren() && /*#__PURE__*/_react.default.createElement("span", {
        className: "data-field_pages"
      }, this.state.page + 1, "/", children.length)), headerRight && /*#__PURE__*/_react.default.createElement("div", {
        className: "data-field_headerRight"
      }, headerRight), this.renderHeaderSelect()), this.renderChildren());
    }
  }]);
  return DataField;
}(_react.PureComponent);
exports.default = DataField;